<template>
	<v-row  style="background: #FAFAFA">
		<v-container>
		
		</v-container>

		<v-container>
			<v-row justify="center">
				<v-data-table
					:headers="headers"
					:items="items"
					:items-per-page=15
					item.key='items.id'
					no-data-text="No hay registros aún ..."
				>

					<!-- slot Top table -->
					<template v-slot:top>
						<v-toolbar flat color="white">
							<v-toolbar-title>Items de ({{category_fullname}})</v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
							<v-spacer />
							<v-col align="right" justify="center" class="my-3">
								<v-btn class="mt-2" fab dark color="secondary" @click="newItem">
									<v-icon dark>mdi-plus</v-icon>
								</v-btn>
							</v-col>
							<!-- <item-dialog /> -->
						</v-toolbar>
					</template>
					<!-- Order -->
					<template v-slot:item.order="{ item }">
							<v-layout justify-center align-center>
								<v-icon @click="toggleOrder(item,'up')" size="32" color="grey darken-1">mdi-menu-up</v-icon>
								{{item.order}}
								<v-icon @click="toggleOrder(item,'down')" size="32" color="grey darken-1">mdi-menu-down</v-icon>
							</v-layout>
					</template>
					<!-- Destacado -->
					<template v-slot:item.featured="{ item }">
						<v-layout justify-center>
							<v-switch
								color="success"
								v-model="item.featured"
								@change="toogleFeatured(item)"
							></v-switch>
						</v-layout>
					</template>
					<!-- Visible -->
					<template v-slot:item.visible="{ item }">
						<v-layout justify-center>
							<v-switch
								color="success"
								v-model="item.visible"
								@change="toogleVisible(item)"
							></v-switch>
						</v-layout>
					</template>
					<template v-slot:item.action="{ item }">
						<v-icon class="botones_list"
						 color="admin_secondary"  
						 @click="editItem(item)">
							mdi-file-edit
						</v-icon>

						<v-icon
						class="botones_list"
							@click="remove(item, items.map(function(x) {return x.id; }).indexOf(item.id))"
							color="secondary"
						>
							mdi-delete
						</v-icon>
					</template>

				</v-data-table>			
			</v-row>
		</v-container>
		<v-container v-if='!loaded' fill-height>
			<v-layout flex align-center justify-center>
				<v-progress-circular indeterminate :size="100" :widht="45" color="secondary" />
			</v-layout>
		</v-container>

		<v-dialog v-model="itemOpenDialog" persistent max-width="680">
			<v-card>
				<v-card-title class="headline">{{ $store.getters['itemModule/itemDialogEditMode'] ? 'EDITAR' : 'CREAR'}} ITEM</v-card-title>
				<v-card-text>
					<v-form v-model="formValidity">
						<v-row>
							<v-col cols="12" md="6">
								<v-text-field
										color="accent"
										v-model="itemForEdit.name"
										label="Nombre"
										prepend-inner-icon="mdi-account-circle"
										dense
										filled />
								<v-select
										multiple
										filled
										dense
										v-model="itemForEdit.alergenos"
										:items="alergenos"
										label="Seleccione Alergenos"
										item-color="secondary"
									 />
								<v-textarea
										color="accent"
										filled
										v-model="itemForEdit.description"
										prepend-inner-icon="mdi-view-headline"
										label="Descripción"
										:value="itemForEdit.description"
										rows="2"/>
								<v-textarea
										color="accent"
										filled
										v-model="itemForEdit.description1"
										prepend-inner-icon="mdi-view-headline"
										label="Descripción 1"
										:value="itemForEdit.address"
										rows="2"/>
								<v-textarea
										color="accent"
										filled
										v-model="itemForEdit.description2"
										prepend-inner-icon="mdi-view-headline"
										label="Descripción 2"
										:value="itemForEdit.address"
										rows="2"/>
								<v-text-field
										color="accent"
										v-model="itemForEdit.price"
										label="Precio"
										prepend-inner-icon="mdi-currency-eur"
										dense
										filled />
								<v-text-field
										color="accent"
										v-model="itemForEdit.price2"
										label="Precio 2"
										prepend-inner-icon="mdi-currency-eur"
										dense
										filled />
							</v-col>
							<v-col cols="12" md="6">
								<v-switch
									inset class="ma-2"
									color="success"
									v-model="itemForEdit.visible"
									:label="`Visible: ${itemForEdit.visible ? 'SI' : 'NO'}`" />
								<v-switch
									inset class="ma-2"
									color="success"
									v-model="itemForEdit.featured"
									:label="`Destacado: ${itemForEdit.featured ? 'SI' : 'NO'}`" />
								
								
								<v-card>
									<image-uploader
										ref="imager"
										:maxWidth="600"
										:quality="0.7"
										:preview="true"
										:className="['fileinput', { 'fileinput--loaded': hasImage }]"
										:capture="false"
										:debug="1"
										doNotResize="gif"
										:autoRotate="true"
										outputFormat="verbose"
										@input="setImage"
									>
										<label for="fileInput" slot="upload-label">
											<v-img 
												v-if="showItemImage"
												:src="(photoItemExist) ? itemForEdit.photo_url : photo.dataUrl"
												aspect-ratio="1.778"
											/>
											<span class="upload-caption"><v-icon >mdi-camera</v-icon> {{
												hasImage ? "Click Reemplazar" : "Click para subir"
											}}</span>
										</label>
									</image-uploader>
								</v-card>							
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn :loading="saving" class="white--text" color="accent" @click.stop="updateItem" v-if="$store.getters['itemModule/itemDialogEditMode']">ACTUALIZAR ITEM</v-btn>
					<v-btn :loading="saving" class="white--text" color="accent" @click.stop="addItem" v-else>CREAR ITEM</v-btn>
					<v-btn outlined color="secondary" @click="closeDialog">CANCELAR</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-row>
</template>

<script>
	import {mapState, mapActions, mapGetters } from 'vuex';
	import { db,storage } from '@/main';
	import AlergenoService from '@/services/AlergenoServices'
	export default {
		name: 'items',
		props: ['business_id','category_id','category_fullname'],
		mounted(){
			//console.log( this.category_id)
			this.getItems( this.business_id, this.category_id )
			this.itemForEdit = this.$store.getters['itemModule/itemForEdit']
			this.alergenos = AlergenoService.getAlergenos() 
		},
		data() {
			//const subtitle = (this.category_subtitle != null ) ? this.category_subtitle : ''
			return {
				hasImage: false,
				itemOpenDialog: false,
				itemForEdit: {
					id: '',
					category_id: '',
					description: '',
					description1: '',
					description2: '',
					name: '',
					order: 1,
					photo_name: '',
					photo_url: '',
					price: '',
					visible: true,
					featured: false,
					alergenos: []
				},
				items: [],
				loaded: false,
				headers: [
					{text: 'Nombre', value: 'name', align: 'left'},
					//{text: 'Descripcion', value: 'description', align: 'left'},
					{text: 'Orden', value: 'order', align: 'center'},
					{text: 'Destacado', value: 'featured', align: 'center'},
					{text: 'Visible', value: 'visible', align: 'center'},
					{text: '', value: 'action', sortable: false,align: 'end', },
				],
				saving: false,
				alergenos: [],
				noImage: '/static/images/not-logo.jpg',
				photo: {
					dataUrl: '/img/static/not-logo.jpg'
				},
				uploaded: false,
				formValidity: false,
				textRules: [v => !!v || "Este dato es requerido"],
				}
		}, //.v-data
		methods: {
			...mapActions('itemModule', ['toggleItemDialog']),
			setImage: function(output) {
				this.hasImage = true;
				this.photo = output;
				this.uploaded = true;
				this.itemForEdit.photo_url = null
			},
			getItems(bus_id,cat_id){
				let regs = []
				try {
					this.loaded = false
					db.collection('bussiness').doc(bus_id)
						.collection('items').where('category_id','==',cat_id)
						.orderBy('order')
						.onSnapshot(snap => {
							regs = []
							snap.forEach(doc => {
								regs.push({ id: doc.id, ...doc.data() })
							})
							this.items = regs;					
							this.loaded = true;
					});						
				} catch (error) { 
					console.log(error) 
					} finally {
						this.loaded = true;
					} 
			}, // .getItems
			toogleFeatured(item){
				db.collection('bussiness').doc(this.business_id)
					.collection('items').doc(item.id)
					.update({ featured: item.featured });
			},
			toogleVisible(item){
				db.collection('bussiness').doc(this.business_id)
					.collection('items').doc(item.id)
					.update({ visible: item.visible });
			},
			toggleOrder(item,to){
				if ( to == 'down' && item.order < this.items.length){
					const nextItem = this.items.find(e => e.order === item.order+1 )
					db.collection('bussiness').doc(this.business_id)
						.collection('items').doc(item.id).update({ order: item.order+1 });
					db.collection('bussiness').doc(this.business_id)
						.collection('items').doc(nextItem.id).update({ order: item.order });
				} else if (to == 'up' && item.order > 1) {
					const nextItem = this.items.find(e => e.order === item.order-1 )
					db.collection('bussiness').doc(this.business_id)
						.collection('items').doc(item.id).update({ order: item.order-1 });
					db.collection('bussiness').doc(this.business_id)
						.collection('items').doc(nextItem.id).update({ order: item.order });
				}
			},
			newItem(){
				this.itemForEdit =  {
						id: '',
						category_id: '',
						description: '',
						description1: '',
						description2: '',
						name: '',
						order: 1,
						photo_name: '',
						photo_url: '',
						price: '',
						visible: true,
						featured: false,
						alergenos: []
					}

				this.$store.commit('itemModule/SET_ITEM', this.itemForEdit, {root: true})
				this.$store.commit('itemModule/SET_EDIT_MODE', false, {root: true})
				this.hasImage = false;
				this.photo = null;
				this.uploaded = false;
				this.itemOpenDialog = true;
			},
			editItem(ittm){
				//this.toggleItemDialog({editMode: true, item})
				this.$store.commit('itemModule/SET_ITEM', ittm, {root: true})
				this.$store.commit('itemModule/SET_EDIT_MODE', true, {root: true})
				this.itemForEdit = ittm
				this.hasImage = false;
				this.photo = null;
				this.uploaded = false;
				this.itemOpenDialog = true;
			},
			async remove(item, index){

				let res = await this.$confirm('Borrará un ITEM. Acción no recuperaable',
						{
							title: "CUIDADO",
							buttonTrueText: "Aceptar",
							buttonFalseText: "Cancelar",
							color: "red",
							icon: "mdi-hand-right",
							width: 350,
							property: "$confirm",
						})
				if (res) {
					this.items.splice(index,1)
					db.collection('bussiness').doc(this.business_id)
					.collection('items').doc(item.id).delete();
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,
							color: 'error',
							message: 'Item eliminado satisfactoriamente',
							timeout: 1000
						});	
				}

			},
			uploadPhoto(event,type) {
				const extensionFile = event.target.files[0].type;
				if(extensionFile === 'image/jpeg' || extensionFile === 'image/png'){
					this.file = event.target.files[0]
					this.error = null
				}else{
					this.error = 'Archivo no válido'
					this.file = null
					return 
				}
				const reader = new FileReader();
				reader.readAsDataURL(this.file);
				reader.onload = (e) => {
					this.photo = e.target.result
					this.uploaded = true;
				}				
			}, 
			goCategories(){
				this.$store.commit('categoryModule/SET_CATEGORY', {}, {root: true})
				this.$store.commit('SET_SHOW', false, {root: true})
			},	
			async addItem(){
				this.saving = true
				this.itemForEdit.id = Math.floor(Date.now() / 1000).toString();
				const business_id = this.business_id;
				const category_id = this.category_id;
				this.itemForEdit.category_id = this.category_id;
				
				let next = 0;
				await db.collection('bussiness').doc(business_id)
					.collection('items').where('category_id','==',category_id).get()
					.then( (snap) => {
						next = snap.size+1					
					})

				this.itemForEdit.order = next	

				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`items/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.itemForEdit.photo_url = await refPhoto.getDownloadURL()
					this.itemForEdit.photo_name = fileNamePhoto
					this.photo = null
				}

				db.collection('bussiness').doc(business_id)
					.collection('items').doc(this.itemForEdit.id)
					.set( this.itemForEdit )
					.then( docRef => {
						this.closeDialog();
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,
							color: 'success',
							message: 'Item creado satisfactoriamente',
							timeout: 3000
						});	
						this.saving = false
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	
					})	

			}, // .add,
			async updateItem(){
				this.saving = true
				const business_id = this.business_id;
				const category_id = this.category_id;

				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`items/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.itemForEdit.photo_url = await refPhoto.getDownloadURL()
					this.itemForEdit.photo_name = fileNamePhoto

					this.hasImage = false;
					this.photo = null;
					this.uploaded = false;

				}

				db.collection('bussiness').doc(business_id)
					.collection('items').doc(this.itemForEdit.id)
					.update( this.itemForEdit )
					.then( docRef => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,color: 'success',timeout: 3000,
							message: 'Item actualizado satisfactoriamente',
						});	
						this.closeDialog();
						this.saving = false
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	
					})
			},		
			closeDialog(){
				const ittm =  {
					id: '',
					category_id: '',
					description: '',
					description1: '',
					description2: '',
					name: '',
					order: 1,
					photo_name: '',
					photo_url: '',
					price: '',
					visible: true,
					featured: false,
					alergenos: []
				}
				this.itemForEdit.photo_url = '';
				this.$refs.imager['imagePreview'] = null;
				this.itemOpenDialog = false

			},	
			closeItem(){

				const ittm =  {
					id: '',
					category_id: '',
					description: '',
					description1: '',
					description2: '',
					name: '',
					order: 1,
					photo_name: '',
					photo_url: '',
					price: '',
					visible: true,
					featured: false,
					alergenos: []
				}
				this.$store.commit('categoryModule/SET_SHOW_DATATABLE', true, {root: false})
				this.$store.commit('categoryModule/SET_SHOW_BTN_TOOLBAR', false, {root: false})
				this.$store.commit('itemModule/SET_SHOW_COMPONENT', false, {root: true})
				this.$refs.imager['imagePreview'] = null;
				this.itemForEdit.photo_url = '';
				this.$refs.imager['imagePreview'] = null;
				this.itemOpenDialog = false;
			},		
			

		}, // .methods
		computed: {
			showItemImage(){
				return !this.hasImage && (this.itemForEdit.photo_url != '')
			},
			photoItemExist(){
				return (this.itemForEdit.photo_url != '' && this.itemForEdit.photo_url !== null )
			},
			...mapState(['alert']),
			...mapState('categoryModule',['category']),
			...mapState('itemModule',['item','dialog']),
			...mapGetters('businessModule',['currentBusiness']),
			

		}
		
	}
</script>
<style>

	button.v-btn.v-btn--flat.v-btn--text.theme--light.v-size--default.primary--text{
		color:red !important;
	}
	.botones_list {
		margin: 0px 10px 10px 0px;
			font-size: xx-large!important;
	}
	#fileInput {
		display: none;
	}
</style>

